export default "/img/AU.10f47fac9a0f2affea5889a59020d8cb.png";